import React, { useEffect } from 'react'
import { useLocale } from '../contexts/LocaleContext'
import { APP_STORE_URL, PLAY_STORE_URL, getPlatform } from '../constants/stores'
import StoreBadges from './StoreBadges'

function DownloadRedirect() {
  const { t } = useLocale()

  useEffect(() => {
    const platform = getPlatform()
    if (platform === 'ios') window.location.replace(APP_STORE_URL)
    if (platform === 'android') window.location.replace(PLAY_STORE_URL)
  }, [])

  return (
    <section className="section coach-invite">
      <div className="container coach-invite-container">
        <div className="coach-invite-card download-card">
          <h1>{t.download.pageTitle}</h1>
          <p className="lead">{t.download.pageDescription}</p>
          <StoreBadges showAll className="store-badges--center" />
        </div>
      </div>
    </section>
  )
}

export default DownloadRedirect
